module.exports = __webpack_public_path__ + "static/media/onoiwa-preview.85ec3375.png";